import getDateRangeLabel from '@lib/utils/getDateRangeLabel';

// Compared completions can span several days, so a single date isn't enough —
// this collapses their createdAt spread into one label (see getDateRangeLabel).
export default function getCompareDateRangeLabel(
  dates: (string | null | undefined)[],
): string | undefined {
  const sortedDates = dates.filter((date): date is string => !!date).sort();
  if (!sortedDates.length) return undefined;

  return getDateRangeLabel(sortedDates[0], sortedDates[sortedDates.length - 1]);
}
